import { render, staticRenderFns } from "./InspectorRating.vue?vue&type=template&id=7c1c603f&scoped=true&"
import script from "./InspectorRating.vue?vue&type=script&lang=js&"
export * from "./InspectorRating.vue?vue&type=script&lang=js&"
import style0 from "./InspectorRating.vue?vue&type=style&index=0&id=7c1c603f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1c603f",
  null
  
)

export default component.exports